"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _theme.makeStyles)(function (props) {
  return {
    apHeader: function apHeader(props) {
      return _defineProperty({
        padding: '50px 2.25% 0px',
        height: props.height ? props.height : '190px',
        backgroundColor: '#FDFDFD',
        borderBottom: '1px solid rgba(34, 34, 34, 0.1)',
        '& h1': {
          margin: '8px 0 19px 0',
          fontSize: '28px !important',
          lineHeight: '38px !important',
          fontWeight: 400
        }
      }, "@media (max-width: ".concat(props.breakpoint ? props.breakpoint : '800px', ")"), {
        paddingBottom: props.responsive ? '175px !important' : undefined
      });
    },
    apTitle: function apTitle(props) {
      return _objectSpread({}, props.titleStyle);
    },
    stickyHeader: {
      position: 'sticky',
      top: props.stickyPositionTopStyle ? props.stickyPositionTopStyle : '0px',
      height: props.height ? props.height : '178px',
      zIndex: 101,
      padding: '38px 2.25% 0px !important'
    },
    tabsAndCta: function tabsAndCta(props) {
      return _defineProperty({
        transform: 'translateY(-7px)',
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '15px'
      }, "@media (max-width: ".concat(props.breakpoint ? props.breakpoint : '800px', ")"), {
        flexDirection: props.responsive ? 'column-reverse' : 'row'
      });
    },
    apPageTabs: {
      flexGrow: 1
    },
    apRightAlignedCta: function apRightAlignedCta(props) {
      return _defineProperty({
        flexGrow: 1,
        alignContent: 'right',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'inherit'
      }, "@media (max-width: ".concat(props.breakpoint ? props.breakpoint : '800px', ")"), {
        alignItems: props.responsive ? 'flex-start' : 'flex-end',
        minWidth: props.responsive ? 'max-content' : 'inherit'
      });
    },
    apBody: {
      minHeight: 'calc(100vh - 310px)',
      position: 'relative',
      padding: 0,
      height: '100%',
      '& > *': {
        padding: '0 1.25%'
      },
      '& > *.noPadding': {
        padding: '0'
      }
    },
    stickyBody: {
      minHeight: 'calc(100vh - 220px)'
    },
    withTabs: {
      transform: 'translateY(-62px)',
      width: '100%'
    }
  };
}, {
  name: 'APMainLayout'
});
exports.useStyles = useStyles;